import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Transition from 'react-transition-group/Transition';

import { fadeIn } from '../constants/keyframes';
import { fontStyles } from '../constants/styles';
import { fonts, fontFallbackStack, typeSizes } from '../constants/typography';
import isMobile from '../helpers/ismobile';


const durationFade = 2500;

const IntroContainer = styled.div`
  background-color: white;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  animation-name: ${({ transition }) => (transition !== 'entered' ? fadeIn : 'none')};
  animation-duration: ${durationFade}ms;
  animation-timing-function: ease-in;
  animation-direction: reverse;
  cursor: none;
`;

const IntroHeading = styled.h1`
  font-size: ${typeSizes.s};
  ${fontStyles.uppercase}
  font-family: ${(props) => props.fontLoaded ? fonts.fontFamily : fontFallbackStack};
  margin: 0;
  text-align: center;
`;

export default class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.setCursorPosition = this.setCursorPosition.bind(this);
    this.cursorRef = React.createRef();
    this.state = {
      isClient: false,
      fontLoaded: false,
    };
  }

  componentDidMount() {
    this.setState({ isClient: true });
    window.addEventListener('mousemove', this.setCursorPosition);

    // Font loading logic to minimize CLS. The load can reject (aborted
    // request on unload, offline); without the catch that surfaces in Sentry
    // as an unhandled rejection. Either way we keep the fallback stack.
    if (document.fonts) {
      document.fonts.load("1em 'Untitled'")
        .then(() => this.setState({ fontLoaded: true }))
        .catch(() => {});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.setCursorPosition);
  }

  setCursorPosition({ clientX, clientY }) {
    const { innerWidth, innerHeight } = window;
    const node = this.cursorRef.current;

    if (!node || !this.props.splashScreenVisible) {
      window.removeEventListener('mousemove', this.setCursorPosition);
      return;
    }

    const [x, y] = [(clientX - (innerWidth / 2)), (clientY - (innerHeight / 2))];
    node.style.transform = `translate(${x}px, ${y}px)`;
  }

  render() {
    const { splashScreenVisible, onClick } = this.props;
    const { isClient, fontLoaded } = this.state;

    const imgStyles = {
      position: 'absolute',
      height: '100px',
      width: '100px',
      backgroundImage: 'url("/Michelberger-Prism.png")',
      backgroundPosition: 'auto auto',
      backgroundSize: '100%',
      pointerEvents: 'none',
    };

    return (
      <Transition exit in={splashScreenVisible} timeout={durationFade} unmountOnExit>
        {(state) => (
          <IntroContainer data-splash="" onClick={onClick} transition={state}>
            <IntroHeading fontLoaded={fontLoaded}>
              Michelberger
            </IntroHeading>
            {isClient && !isMobile() && (
              <div ref={this.cursorRef} style={imgStyles} />
            )}
          </IntroContainer>
        )}
      </Transition>
    );
  }
}

SplashScreen.propTypes = {
  splashScreenVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
